import type { SortType } from '../types';

export const artworksSortOptions: {
  text: string;
  value: SortType;
}[] = [
  {
    text: 'Artist A-z',
    value: {
      column: 'artist',
      order: 'asc',
    },
  },
  {
    text: 'Artist z-A',
    value: {
      column: 'artist',
      order: 'desc',
    },
  },
  {
    text: 'Artwork Title A-z',
    value: {
      column: 'name_english',
      order: 'asc',
    },
  },
  {
    text: 'Artwork Title Z-a',
    value: {
      column: 'name_english',
      order: 'desc',
    },
  },
  // {
  //   text: 'High Price',
  //   value: {
  //     column: 'price',
  //     order: 'desc',
  //   },
  // },
  // {
  //   text: 'Low Price',
  //   value: {
  //     column: 'price',
  //     order: 'asc',
  //   },
  // },
  {
    text: 'Newest',
    value: {
      column: 'year',
      order: 'desc',
    },
  },
  {
    text: 'Oldest',
    value: {
      column: 'year',
      order: 'asc',
    },
  },
];
